import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Embed.scss';

const Embed = ({ content }) => {
	useEffect(() => (
		() => {
			[...document.head.querySelectorAll('.js-embedScripts')].map((node) => node && node.remove());
		}
	), [content.rawText]);

	return (
		<div className={s.embed} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, { ADD_TAGS: ['iframe', 'script'], KEEP_CONTENT: false }) }} />
	);
};

export default hot(module)(Embed);
